// import Handlebars from "handlebars";

if (typeof L2H === 'undefined' || L2H === null) { window.L2H = {}; }

L2H.Widget = class Widget {
  constructor($container, photosURL, options) {
    this.preferences = {}
    $.extend(this.preferences, L2H.preferences);
    if (options.ts === "large") {
      this.preferences.useLargeThumbs = true;
    }
  }
};
